import { getRemainingDays } from '../utils';

export function formatPendingReviewCount(count, locale = 'es-AR') {
  const numericCount = Number(count) || 0;
  return numericCount.toLocaleString(locale);
}

export function getPendingReviewElapsedDays(item = {}) {
  if (typeof item.pending_days === 'number') {
    return item.pending_days;
  }

  if (typeof item.days_pending === 'number') {
    return item.days_pending;
  }

  if (typeof item.daysPending === 'number') {
    return item.daysPending;
  }

  const timestamp =
    item.pending_since || item.submitted_at || item.created_at || null;

  if (!timestamp) {
    // ToDo: confirm which timestamp the dashboard card payload will expose
    return 0;
  }

  return Math.abs(getRemainingDays(timestamp));
}

export function getPendingReviewDisplayTime(item, todayLabel) {
  if (item?.display_time || item?.displayTime) {
    return item.display_time || item.displayTime;
  }

  const days = getPendingReviewElapsedDays(item);
  if (!Number.isFinite(days) || days <= 0) {
    return todayLabel;
  }

  return `${days}d`;
}

export function mapPendingReviewItem(item = {}) {
  return {
    id: item.id,
    picture:
      item.picture_url ||
      item.property_picture_url ||
      item.development_picture_url ||
      item.picture ||
      item.image_url ||
      '',
    address: item.address || item.name || '',
    location: item.location || item.subtitle || item.description || '',
    daysPending: getPendingReviewElapsedDays(item),
    displayTime: item.display_time,
    changesCount: item.changes_count ?? 0,
    raw: item,
  };
}
